/* tslint:disable:import-spacing */
/*
tslint:disable:typedef-whitespace
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import {ICommand}        from '@/util/i.command';
import {DecisionPoint}   from '@/models/scenario/decision.point';
import {DiversionEditor}  from './diversion.editor';

/**
 *
 * @class SetStartLocCommand
 *
 * @brief reversible updates of the starting decision point for a diversion
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2020
 *
 */
export class SetStartLocCommand implements ICommand {

  private oldValue: DecisionPoint;
  private newValue: DecisionPoint;
  private editor:   DiversionEditor;

  constructor(oldValue: DecisionPoint, newValue: DecisionPoint, editor: DiversionEditor) {

    this.oldValue = oldValue;
    this.newValue = newValue;
    this.editor   = editor;
  }

  /** effect the command */
  execute() {

    this.editor.setStartLoc(this.newValue);
  }

  /** reverse the command's effects */
  unExecute() {

    this.editor.setStartLoc(this.oldValue);
  }

  /** return a string summary of this command */
  asString(): string {

    const a = (this.oldValue instanceof DecisionPoint) ? this.oldValue.asString() : '';
    const b = (this.newValue instanceof DecisionPoint) ? this.newValue.asString() : '';

    return '[startloc] ' + a + ' => ' + b;
  }

}
